export default "__VITE_ASSET__B$HT4ckm__"